import { withStyles, StyleRules, WithStyles, StyleRulesCallback, Theme } from '@material-ui/core/styles';
import * as React from 'react';
import { pure } from 'recompose';
import { CircularProgress, Typography } from '@material-ui/core';

type CssClasses = 'loading' |'circular'

const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100vh'
  },
  circular: {
    marginBottom: theme.spacing.unit
  },
});

interface Props {
  centered?: boolean
}

const Loading = ({ classes }: Props & WithStyles<CssClasses>) => (
  <div className={classes.loading}>
    <CircularProgress color={'primary'} size={50} className={classes.circular}/>
    <Typography>Loading</Typography>
  </div>
);

export default withStyles(styles)(pure(Loading));



// WEBPACK FOOTER //
// ./src/components/Loading.tsx